import React from 'react';
import { QUEUE_LIFECYCLE_OPTIONS, normalizeQueueLifecycle } from './workQueueStatus.js';

const SELECT_CLASS = {
  open: 'bg-slate-100 text-slate-800 border-slate-300',
  working: 'bg-amber-50 text-amber-900 border-amber-300',
  closed: 'bg-emerald-50 text-emerald-900 border-emerald-300',
};

/**
 * Queue item status control. This is status, not an action (Open / Assign / Delete).
 */
export function QueueStatusControl({ status, onChange, disabled = false }) {
  const value = normalizeQueueLifecycle(status);
  return (
    <select
      value={value}
      disabled={disabled}
      aria-label="Queue status"
      title="Queue status"
      onClick={(e) => e.stopPropagation()}
      onChange={(e) => {
        e.stopPropagation();
        const next = e.target.value;
        if (next !== value && typeof onChange === 'function') onChange(next);
      }}
      className={`block w-full min-w-[7.5rem] max-w-[9.5rem] rounded-md border px-2 py-1 text-xs font-medium ${
        SELECT_CLASS[value] || SELECT_CLASS.open
      } ${disabled ? 'opacity-60 cursor-not-allowed' : 'cursor-pointer'}`}
    >
      {QUEUE_LIFECYCLE_OPTIONS.map((opt) => (
        <option key={opt.value} value={opt.value}>
          {opt.label}
        </option>
      ))}
    </select>
  );
}
